import React from 'react';
import './Flyout.scss';
import FlyoutContentWithFooter from './FlyoutContentWithFooter';
import FlyoutHeader from './FlyoutHeader';
// import mock from './flyoutMock.json';

export const COMPONENT_NAME = 'flyout';

const Flyout = (props) => {
  const { info, Modal, option } = props;
  return (
    <div className="Flyout">
      <div className="content">
        <FlyoutHeader {...info.header} />
        <FlyoutContentWithFooter content={info.content} option={option} Modal={Modal} />
      </div>
    </div>
  );
};

export default Flyout;
